import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entrepreneursguide',
  templateUrl: './entrepreneursguide.component.html',
  styleUrls: ['./entrepreneursguide.component.css']
})
export class EntrepreneursguideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
